import team_1 from '../../../../assets/images/team_1.png';
import team_2 from '../../../../assets/images/team_2.png';
import Player1 from '../../../../assets/images/Home_team_player1.png';
import Away_team_player from '../../../../assets/images/away_team_player1.png';
import { getZoneCatByZoneArea, zoneCatByZoneArea, zoneDataByZoneCat } from '../../../Sports/Courts/BasketballCourt/court.data';

export const TEAM_TYPE = {
    HOME_TEAM: "Home Team",
    AWAY_TEAM: "Away Team"
}

export const TEAM_TYPE_COLORS = {
    home_team_colors: {
        expanded_background:"linear-gradient(180deg, rgba(7, 13, 78, 0.90) 0%, rgba(66, 74, 165, 0.90) 100%)",
        collapsed_background:"#ffffff1c",
        team_type_text:"#A5CAFF",
        team_name_text:"#fff",
        player_name_box:"#020529",
        player_name_text_color: "white",
        score_color:"#B98B00"

    },
    away_team_colors:{
        expanded_background:"linear-gradient(rgb(84, 32, 9, 0.90) 0%, rgb(163, 137, 33, 0.90) 100%)", 
        collapsed_background:"#612b13ab",
        team_type_text:"#A5CAFF",
        team_name_text:"#fff",
        player_name_box:"#57240a",
        player_name_text_color: "white",
        score_color: "#B98B00"
    }
}

export const TEAMS_DETAIL = [
    {
        teamName: "DePaul Blue Demons",
        teamImage: team_1,
        teamType: TEAM_TYPE.HOME_TEAM,
        teamScore: "10",
        substitutePlayer: [
            {
                playerId: "01",
                playerName: "Nate Kasher",
                profilePic: Player1,
                jerseyNumber: "3",
            },
            {
                playerId: "02",
                playerName: "Layden Blocker",
                profilePic: Player1,
                jerseyNumber: "8",
            },
            {
                playerId: "03",
                playerName: "Layden Blocker",
                profilePic: Player1,
                jerseyNumber: "8",
            },
            {
                playerId: "04",
                playerName: "Layden Blocker",
                profilePic: Player1,
                jerseyNumber: "8",
            },
            {
                playerId: "05",
                playerName: "Layden Blocker",
                profilePic: Player1,
                jerseyNumber: "8",
            }

        ],

        teamPlayers: [
            {
                playerId: "1",
                playerName: "JJ Traynor",
                profilePic: Player1,
                jerseyNumber: "20",
                isSubstitute: true,
            },
            {
                playerId: "2",
                playerName: "CJ Gunnn",
                profilePic: Player1,
                jerseyNumber: "9",
            },
            {
                playerId: "3",
                playerName: "CJ Gunnn",
                profilePic: Player1,
                jerseyNumber: "9",
            },
            {
                playerId: "4",
                playerName: "CJ Gunnn",
                profilePic: Player1,
                jerseyNumber: "9",
            },
            {
                playerId: "5",
                playerName: "CJ Gunnn",
                profilePic: Player1,
                jerseyNumber: "9",
            },
            {
                playerId: "6",
                playerName: "CJ Gunnn",
                profilePic: Player1,
                jerseyNumber: "9",
            },
            {
                playerId: "7",
                playerName: "CJ Gunnn",
                profilePic: Player1,
                jerseyNumber: "9", 
            },
            {
                playerId: "8",
                playerName: "CJ Gunnn",
                profilePic: Player1,
                jerseyNumber: "9",
            },
            {
                playerId: "9",
                playerName: "CJ Gunnn",
                profilePic: Player1,
                jerseyNumber: "9",
            },
            {
                playerId: "10",
                playerName: "CJ Gunnn",
                profilePic: Player1,
                jerseyNumber: "9",
            },
            {
                playerId: "11",
                playerName: "CJ Gunnn",
                profilePic: Player1,
                jerseyNumber: "9",
            }
        ]
    },
    {
        teamName: "Dayton Flyers",
        teamImage: team_2,
        teamType: TEAM_TYPE.AWAY_TEAM,
        teamScore: "8",

        teamPlayers: [
            {
                playerId: "1",
                playerName: "Javon Bannett",
                profilePic: {Away_team_player},
                jerseyNumber: "7",
                isSubstitute: true
            },
            {
                playerId: "2",
                playerName: "Atticus Schuler",
                profilePic: {Away_team_player},
                jerseyNumber: "14",
            },
        ]
    },
]

export const GAME_ENDED = 'GAME ENDED'

export const isCurrentGameEnded = (gameDetails) => {
    if(!gameDetails) return;
    return (gameDetails?.currentSession === GAME_ENDED || gameDetails?.isGameEnded);
}

export const convertSecondsToTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    return { hours: hours <= 0 ? 0 : hours, minutes: minutes <= 0 ? 0 : minutes, seconds: remainingSeconds <= 0 ? 0 : remainingSeconds };
};

export const convertTimeToSeconds = (currentTime) => {
    const seconds =
      (currentTime.hours || 0) * 3600 +
      (currentTime.minutes || 0) * 60 +
      (currentTime.seconds || 0);

    return seconds;
};

export const getZoneName = (zone, zoneCategories) => {
    let zoneCat = getZoneCatByZoneArea(zone);
    let zoneData = zoneDataByZoneCat(zoneCat, zoneCategories);
    const indexInZoneCatByZoneName = zoneCatByZoneArea[zoneCat]?.indexOf(zone);
    const { zoneName } = zoneData?.zones[indexInZoneCatByZoneName] || {}

    return zoneName;    
}

export const calculateScore = async ({ teamType, selectedAction, selectedSubAction, selectedZones, gameDetails }) => {
    // Calculate the score
    let _action = null;
    if (selectedSubAction) {
      _action = selectedSubAction;
    } else {
      _action = selectedAction;
    }

    if (!_action) return;

    // actionScores: [
    //   { zoneNumber: "1", zoneName: "Zone 1", sameTeamScores: 2, anotherTeamScores },
    //   { zoneNumber: "2", zoneName: "Zone 2", score: 3 }
    // ],
    const _scoreForAction = await _action.actionScores;
    if (!_scoreForAction || !_scoreForAction.length) return;

    if (selectedZones?.length === 0) return;

    const _zone = selectedZones?.[selectedZones?.length - 1];

    const _scoreForZone = _scoreForAction.find(s => s?.zoneNumber?.toString() === _zone.toString());
    if (!_scoreForZone) return;

    if((gameDetails?.homeTeamDefensiveBasketZone === 1) && (teamType === TEAM_TYPE.HOME_TEAM)) {
      return _scoreForZone.anotherTeamScores;
    } else if((gameDetails?.awayTeamDefensiveBasketZone === 9) && (teamType === TEAM_TYPE.AWAY_TEAM)) {
      return _scoreForZone.sameTeamScores;
    } else if((gameDetails?.homeTeamDefensiveBasketZone === 9) && (teamType === TEAM_TYPE.HOME_TEAM)) {
      return _scoreForZone.sameTeamScores;
    } else if((gameDetails?.awayTeamDefensiveBasketZone === 1) && (teamType === TEAM_TYPE.AWAY_TEAM)) {
      return _scoreForZone.anotherTeamScores;
    } else {
      return 0;
    }
}